import React from 'react';
import { Redirect } from 'react-router';
import { useSelector } from 'react-redux';

import type { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import {
  FEATURE_FLAGS,
  ROUTE_TYPE_GUIDED_SELF_HELP,
  ROUTE_TYPE_SELF_HELP,
} from '../../../config/constants';
import useRoutes from '../../../hooks/useRoutes';
import Loader from '../../../components/Loader';
import CustomRoute from '../CustomRoute';
import type { CustomRouteProps } from '../types';

const PublicRoute: React.FC<CustomRouteProps> = ({ search, children, ...restProps }) => {
  const { program } = useRoutes(ROUTE_TYPE_SELF_HELP);
  const { clients } = useRoutes(ROUTE_TYPE_GUIDED_SELF_HELP);

  const isLoggedIn = useSelector<ImmutableRootState<boolean | null>, boolean | null>(
    (state) => state.getIn(['login', 'loggedIn'], null),
  );

  return (
    <CustomRoute
      {...restProps}
      render={(routeProps) => {
        switch (isLoggedIn) {
          case false: {
            if (typeof children === 'function') {
              return children(routeProps);
            }

            return children;
          }

          case true:
            return (
              <Redirect
                to={{
                  pathname: FEATURE_FLAGS.zelfhulp_poh ? clients : program,
                  state: { from: routeProps.location },
                  search,
                }}
              />
            );

          default:
            return <Loader />;
        }
      }}
    />
  );
};

export default PublicRoute;
